import React from 'react';
import { Skeleton } from '../../../../shared/components/skeleton/skeleton';

const SWATCH_SKELETON_COUNT = 3;

export default function ProductListItemSkeleton() {
    return (
        <div
            className='bs-product-list-container__item bs-product-list-container__item--skeleton'
            data-testid='plp-product-card-skeleton'
            aria-hidden='true'
        >
            <div className='bs-product-list-container__item__image-wrapper'>
                <Skeleton />
            </div>
            <Skeleton className='bs-product-list-container__item__price-skeleton' />
            <Skeleton className='bs-product-list-container__item__title-skeleton' />
            <div className='bs-product-list-container__item__swatches-skeleton'>
                {Array.from({ length: SWATCH_SKELETON_COUNT }, (_, i) => (
                    <Skeleton key={i} className='bs-product-list-container__item__swatch-skeleton' />
                ))}
            </div>
        </div>
    );
}
